(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("SSOLoginController", SSOLoginController);

    SSOLoginController.$inject = ['$state'];

    function SSOLoginController ($state)  {
        var provider = '';

        if ($state.current.name === 'hw_sso_login') {
            provider = 'hallandwoodhouse';
        } else if ($state.current.name === 'mcd_sso_login') {
            provider = 'mcdonalds';
        } else if ($state.current.name === 'fulham_shores_sso_login') {
            provider = 'fulham-shores';
        } else if ($state.current.name === 'mcd_uk_sso_login') {
            provider = 'mcdonalds';
        } else if ($state.current.name === 'fuller_sso_login') {
            provider = 'fullers';
        } else if ($state.current.name === 'shakeshack_sso_login') {
            provider = 'shakeShack';
        } else if ($state.current.name === 'arc_burger_sso_login') {
            provider = 'arcBurger';
        } else if ($state.current.name === 'steaknshake_login') {
            provider = 'steak-and-shake';
        } else if ($state.current.name === 'connectivity_source_sso_login') {
            provider = 'connectivity-source';
        } else if ($state.current.name === 'kfc_sso_login') {
            provider = 'kfc';
        } else if ($state.current.name === 'jib_sso_login') {
            provider = 'jack-in-the-box';
        } else if ($state.current.name === 'firmdale_hotels_sso_login') {
            provider = 'firmdale';
        } else if ($state.current.name === 'subway_sso_login') {
            provider = 'subway';
        } else if ($state.current.name === 'district_taco_sso_login') {
            provider = 'district-taco';
        }  else if ($state.current.name === 'free_birds_sso_login') {
            provider = 'freebirds';
        } else {
            provider = 'Radisson';
        }
        var self = this;

        self.login = function(){
            hLoginManager.getFederateSignInLink(provider).then(function(redirectUrl){
                window.open(redirectUrl, '_self', 'noopener');
            }, function (err) {
                hLog(provider.toUpperCase(), 'REDIRECT_PAGE', err);
                betterSomethingWentWrong();
            });
        };
        self.loginToTeamLive = function () {
            var origin = environmentsConfig.getTeamLiveOrigin();
            window.location.href = origin + '/tl-sso?provider=' + provider;
        };
    }

})();
